export default __webpack_public_path__ + "static/media/banner-bg-1.20c7da15.png";